import { React, useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import '../../node_modules/firebase/compat/firestore';
import { firebaseConfig } from "../firebase-config";

import Box from "@mui/material/Box";
import TicketList from './components/ticketList';
import Sidebar from './components/sidebar'
import {CircularProgress, ThemeProvider, createTheme, responsiveFontSizes } from '@material-ui/core';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

var signedinEmail;

var loading = true


function Dashboard({ isAuth }) {
    const [allDocs,setAllDocs]=useState([]);
    
    let navigate = useNavigate();
    
    // USER AUTHENTICATION
    useEffect(() => {
      const loggedInUser = localStorage.getItem("isAuth");

      if (loggedInUser === "true") { 
        fetchAll();
        loading = false;
      }
      else{
        navigate("/login");
      }
    },[])

    async function fetchAll(){
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user){
          signedinEmail = user.email;
          console.log(signedinEmail)
        }
      })
      //Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      const db = firebase.firestore()
      db.collection("tickets")
      .get()
      .then((snapshot)=>{
        if(snapshot.docs.length>0){
          snapshot.docs.forEach((doc)=>{
            setAllDocs((prev)=>{
              return[...prev,{id: doc.id,...doc.data()}];
            });
          });
        }
      });
    }

    const boxStyle = { display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' };

    return (
      <ThemeProvider theme={theme}>
        <Box height={70} />
        <Box sx={{ display: "flex" }}>
            <Sidebar /> 
            <Box component="main" sx={{ flexGrow: 1, p: 3}}>
              {loading === true ? 
              <Box sx={boxStyle}>
                <CircularProgress thickness={6} sx={{ color: "black"}}/>
              </Box> : <TicketList data={allDocs}/>}
            </Box>
        </Box>
      </ThemeProvider>
    )
}

export default Dashboard